// extracted by mini-css-extract-plugin
export default {"no-data":"NoData_no-data__J6hGD"};